//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'

import RbRegisterForm from '@/elements/login-register/forms/rb-register-form.vue'
import RbLoginForm from '@/elements/login-register/forms/rb-login-form.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

export default {
  name: 'rb-login-modal',
  components: {
    RbRegisterForm,
    RbLoginForm,
    RbModal,
  },
  props: {
    modalWrapperClass: {
      type: String,
      default: 'main',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isFrameAdvisor: {
      type: Boolean,
      default: false,
    },
    loginFormIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGettersPdp(['privateSale']),
  },
  methods: {
    handleClose() {
      this.$emit('closed')
    },
    showLoginForm() {
      this.$emit('showLoginForm')
    },
    showRegisterForm() {
      this.$emit('showRegisterForm')
    },
  },
}
